module.exports = __webpack_public_path__ + "img/0_2.70f3d332.png";